export default __webpack_public_path__ + "static/og-f17470b182f1af14993b18ec22bba868.png";